import {API_URL} from '../settings/local_settings';
import {LocalStorage} from '../utils/LocalStorage';
import {DASHBO_CLIENT_HEADER, DASHBO_CLIENT_HEADER_VALUE} from '../utils/APIClient';

/**
 * Eventos de MEDICIÓN de las guías (paso visto, clic en la acción, ancla no encontrada), en lote.
 * Calcado de `utils/ScreenTracker.js`: buffer en memoria, flush cada 30 s y en `pagehide` con
 * `keepalive`, swap sincrónico del buffer (un doble flush no duplica) y SIN reintentos: perder un
 * evento de medición es aceptable, duplicarlo ensucia el embudo.
 *
 * Lo que cambia el estado del usuario (vista, completada, descartada, pospuesta) NO va por acá:
 * decide si la guía vuelve a salir, así que va directo por `GuidesService.postState`.
 */
const FLUSH_INTERVAL_MS = 30000;
const MAX_BUFFER = 50; // el máximo que acepta el endpoint por lote
const EVENTS_PATH = 'guides/events/';

class GuidesTrackerImpl {
    constructor() {
        this._buffer = [];
        this._timer = null;
        this._pagehideHandler = null;
    }

    track(event) {
        if (!event || !event.guide_id || !event.type) return;
        this._buffer.push(event);
        this._ensureStarted();
        if (this._buffer.length >= MAX_BUFFER) this.flush(false);
    }

    _ensureStarted() {
        if (this._timer || typeof window === 'undefined') return;
        this._timer = setInterval(() => this.flush(false), FLUSH_INTERVAL_MS);
        this._pagehideHandler = () => this.flush(true);
        window.addEventListener('pagehide', this._pagehideHandler);
    }

    flush(useKeepalive = false) {
        if (this._buffer.length === 0) return;
        const events = this._buffer;
        this._buffer = [];
        const token = LocalStorage.fetchUserToken();
        if (!token) return;
        try {
            const result = fetch(API_URL + EVENTS_PATH, {
                method: 'POST',
                headers: {
                    'Authorization': 'Token ' + token,
                    'Content-Type': 'application/json',
                    [DASHBO_CLIENT_HEADER]: DASHBO_CLIENT_HEADER_VALUE,
                },
                body: JSON.stringify({events}),
                ...(useKeepalive ? {keepalive: true} : {}),
            });
            if (result && typeof result.catch === 'function') result.catch(() => {});
        } catch (_) {
            // Sin reintentos, a propósito (ver arriba).
        }
    }

    _reset() {
        if (this._timer) clearInterval(this._timer);
        if (this._pagehideHandler && typeof window !== 'undefined') {
            window.removeEventListener('pagehide', this._pagehideHandler);
        }
        this._timer = null;
        this._pagehideHandler = null;
        this._buffer = [];
    }
}

export const GuidesTracker = new GuidesTrackerImpl();
